module.exports = __webpack_public_path__ + "static/media/verv-logo.e2999819.svg";